export default __webpack_public_path__ + "static/media/DSS_Banner_800x300.158b2a37.jpg";